module.exports = __webpack_public_path__ + "47d275676dc7bb75f78f273dd4dc35e5.png";